import React, { Component } from 'react';
import { Field } from 'react-final-form';
import InputField from '../../../components/InputField';
import DescriptionField from '../../../components/DescriptionField';
import SelectField from '../../../components/SelectField';
import Validators, { required } from '../../../Common/validators';
import { normalizeBarcode, normalizeDate, normalizeValue } from '../../../Common/normalize';

class ZwalletPaymentFormStep2 extends Component {
  render() {
    const { banks, formProps } = this.props;
    const { handleSubmit, invalid } = formProps;

    const optionsBank = banks.map(bank =>
        <option key={bank.code} value={bank.code}>{bank.name}</option>
    );

    return (
      <form onSubmit={handleSubmit}>
        <div className="pl-lg-4">
          <div className="row">
            <div className="col-12 col-md-12">
              <Field
                name="barcode"
                type="text"
                className="form-control"
                label="Código de Barra"
                placeholder="XXXXX.XXXXX XXXXX.XXXXXX XXXXX.XXXXX X XXXXXXXXXXXXXXXX"
                parse={normalizeBarcode}
                validate={Validators(required)}
                component={InputField}
              />
            </div>
          </div>
          <div className="row">
            <div className="col-12 col-md-12">
              <Field
                label="Descrição"
                className="form-control"
                name="description"
                component={DescriptionField}
              />
            </div>
          </div>
          <div className="row">
            <div className="col-12 col-md-4">
              <Field
                label="Data de Vencimento"
                className="form-control"
                name="dueDate"
                placeholder="DD/MM/YYYY"
                parse={normalizeDate}
                validate={Validators(required)}
                component={InputField}
              />
            </div>
            <div className="col-12 col-md-4">
              <Field
                name="bank"
                type="text"
                className="form-control"
                label="Banco"
                validate={Validators(required)}
                options={optionsBank}
                component={SelectField}
              />
            </div>
            <div className="col-12 col-md-4">
              <Field
                label="Valor"
                className="form-control"
                name="amount"
                validate={Validators(required)}
                parse={normalizeValue}
                component={InputField}
              />
            </div>
          </div>
        </div>
        <div className="text-center">
          <button
            type="submit"
            className="btn btn-success mt-4"
            disabled={invalid}>
            Pagar
          </button>
        </div>
      </form>
    );
  }
}

export default ZwalletPaymentFormStep2;


// WEBPACK FOOTER //
// ./src/ZWallet/Payment/components/Form2.js